module.exports = __webpack_public_path__ + "media/images/iconLockOpen__okGreen--dark-8f295dd7c89defdfa0d973dadf10df08.png";